import { render, staticRenderFns } from "./ot-text-field.vue?vue&type=template&id=247c384a&scoped=true&"
import script from "./ot-text-field.vue?vue&type=script&lang=ts&"
export * from "./ot-text-field.vue?vue&type=script&lang=ts&"
import style0 from "./ot-text-field.vue?vue&type=style&index=0&id=247c384a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c384a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
